module.exports = __webpack_public_path__ + "img/logo.3b0352d4.png";